import React, { useEffect, useRef, useState } from "react";
import tr from "../../assets/images/tr.svg";
import en from "../../assets/images/en.svg";
import { IoChevronDown } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { changeLang } from "../../redux/slices/langSlice";
import { motion, AnimatePresence } from "framer-motion";

const LanguageSelection = () => {
  const [modal, setModal] = useState(false);
  const lang = useSelector((state) => state.lang.lang);
  const dispatch = useDispatch();
  const langRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setModal]);

  const handleLanguageChange = (language) => {
    dispatch(changeLang(language));
    setModal(false);
  };

  return (
    <li className="language-selection" ref={langRef}>
      <div className="selected" onClick={() => setModal(!modal)}>
        <div>
          <img src={lang === "tr" ? tr : en} alt="" />
        </div>
        <div>
          <span>{lang === "tr" ? "TR" : "EN"}</span>
        </div>
        <motion.div
          animate={{ rotate: modal ? 180 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <IoChevronDown size={30} />
        </motion.div>
      </div>

      <AnimatePresence>
        {modal && (
          <motion.ul
            className="lang-list"
            initial={{ opacity: 0, y: -10, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -10, height: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: "hidden", transformOrigin: "top" }}
          >
            <li
              className={lang === "tr" ? "active lang-item" : "lang-item"}
              onClick={() => handleLanguageChange("tr")}
            >
              <div>
                <img src={tr} alt="" />
              </div>
              <div>
                <span>TR</span>
              </div>
            </li>
            <li
              className={lang === "en" ? "active lang-item" : "lang-item"}
              onClick={() => handleLanguageChange("en")}
            >
              <div>
                <img src={en} alt="" />
              </div>
              <div>
                <span>EN</span>
              </div>
            </li>
          </motion.ul>
        )}
      </AnimatePresence>
    </li>
  );
};

export default LanguageSelection;
